export default "__VITE_ASSET__7228449c__"